export enum ProductFilling {
	ChocolateWithRaspberries = "ChocolateWithRaspberries",
	ChocolateWithSaltedCaramel = "ChocolateWithSaltedCaramel",
	FruityDark = "FruityDark",
	FruityLight = "FruityLight",
	LemonWithRaspberries = "LemonWithRaspberries",
	PistachioWithRaspberries = "PistachioWithRaspberries",
}
